import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const documentsApi = createApi({
  reducerPath: 'documents',


  baseQuery: createBaseQueryWithReauth('/documents'),
  tagTypes: ['Documents'],

  endpoints: builder => ({

    getDocument: builder.query({
      query: (id) => ({
        url: `/list`,
        method: 'GET',
      }),
      providesTags: ['Documents'],
    }),
    viewDocument: builder.query({
      query: (id) => ({
        url: `/view?id=${id}`,
        method: 'GET',
      }),
      providesTags: ['Documents'],
    }),
    downloadDocument: builder.query({
      query: (id) => ({
        url: `/download?id=${id}`,
        method: 'GET',
        responseHandler: (response) => response.blob(), // Обробка бінарних даних
      }),
      transformResponse: (response) => response,
      providesTags: ['Documents'],
    }),


  }),
});

export const {
  useViewDocumentQuery,
  useDownloadDocumentQuery,
useGetDocumentQuery
} = documentsApi;
